import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { ITopic } from 'app/shared/model/topic.model';
import { getEntities as getTopics } from 'app/entities/topic/topic.reducer';
import { createEntityinspirations, deleteInspirationEntity, getEntityInspirations } from 'app/entities/inspiration/inspiration.reducer';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Container, Row, Col, Button, Label, Spinner, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { JhiItemCount, JhiPagination, Translate, getSortState } from 'react-jhipster';
import InspirationUpdate from './inspirations-update';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { renderPreview } from 'app/shared/common-fun';
import Select, { components } from 'react-select';

const InspirationPage: React.FC = () => {
  const inspirationEntity = useAppSelector(state => state.inspiration.entity);
  const account = useAppSelector(state => state.authentication.account);
  const [selectedInspirationId, setSelectedInspirationId] = useState(null);
  const [inspirationData, setInspirationData] = useState([]);
  const loading = useAppSelector(state => state.inspiration.loading);
  const [showView, setShowView] = useState('list');
  const baseImageUrl = '/image';
  const baseImageUrlProfile = '/profile/get/image';
  const dispatch = useAppDispatch();
  const id = account.id;
  const navigate = useNavigate();
  const topics = useAppSelector(state => state.topic.entities);
  const [selectedTopicOptions, setSelectedTopicOptions] = useState<{ value: string; label: string }[]>([]);

  const [appliedTopics, setAppliedTopics] = useState<string[]>([]);

  const totalItems = useAppSelector(state => state.inspiration.totalItems);
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, 20, 'id', 'desc'), location.search)
  );
  const topicOptions = topics.map(topic => ({
    value: topic.id,
    label: topic.name,
  }));

  // useEffect(() => {
  //   //dispatch(getEntityInspirations(id));
  // }, []);
  useEffect(() => {
    if (!loading) {
      const data = Array.isArray(inspirationEntity) ? inspirationEntity : inspirationEntity?.content || [];

      setInspirationData(data);
    }
  }, [loading, inspirationEntity]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!isFirstRender.current) {
      dispatch(
        getEntityInspirations({
          id,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
          topics: appliedTopics,
        })
      );
    } else {
      isFirstRender.current = false;
    }
  }, [paginationState, appliedTopics]);
  const handleSubmit = async () => {
    await dispatch(
      getEntityInspirations({
        id: id,
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
    setShowView('list');
  };
  const deleteInspiration = async id => {
    await dispatch(deleteInspirationEntity(id));
    await dispatch(
      getEntityInspirations({
        id: account.id,
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };
  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleTopicSelect: any = (selected: { value: string; label: string }[] | null) => {
    const selectedOptions = selected || [];
    setSelectedTopicOptions(selectedOptions);
    if (selectedOptions.length === 0) {
      setAppliedTopics([]);
    }
  };

  const handleTopicFilter = () => {
    const selectedTopics = selectedTopicOptions.map(topic => topic.label);
    setAppliedTopics(selectedTopics);

    setPaginationState(prev => ({
      ...prev,
      activePage: 1,
    }));
  };

  function formatDate(dateString) {
    const inputDate = new Date(dateString);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    if (inputDate >= currentDate) {
      const options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      };

      return 'Today ' + inputDate.toLocaleTimeString('en-US', options as Intl.DateTimeFormatOptions);
    } else {
      const oneDayAgo = new Date(inputDate);
      oneDayAgo.setUTCDate(inputDate.getUTCDate() - 1);

      const options = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      };

      return oneDayAgo.toLocaleString('en-US', options as Intl.DateTimeFormatOptions);
    }
  }

  return (
    <Container className="inspiration-page card meeting-border">
      {showView == 'edit' && <InspirationUpdate inspirationId={selectedInspirationId} handleSubmit={handleSubmit} showView={showView} />}
      {showView == 'add' && <InspirationUpdate inspirationId={selectedInspirationId} handleSubmit={handleSubmit} showView={showView} />}
      {loading && <Spinner className="body-loader-icon" />}
      {!loading && (
        <>
          <Row className="page-header">
            <Col md="6" className="heading">
              <h1>My Inspiration</h1>
            </Col>
            <Col md="6" className="add-btn">
              {showView !== 'add' && (
                <div className="inspiration-add-btn d-flex align-items-center justify-content-center gap-2">
                  <FontAwesomeIcon icon="plus" />
                  <Label
                    className="add-new-btn text-nowrap fs-6"
                    onClick={() => {
                      setSelectedInspirationId(null);
                      setShowView('add');
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                  >
                    Add new Inspiration
                  </Label>
                </div>
              )}
            </Col>
          </Row>
          <div className="mb-3">
            <Label className="fs-5 fw-semibold">Filter by Topics</Label>

            <div className="d-flex align-items-center gap-2">
              <div className="flex-grow-1">
                <Select
                  options={topicOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  value={selectedTopicOptions}
                  onChange={handleTopicSelect}
                  placeholder="Select topics..."
                />
              </div>

              <Button color="primary" className="px-4 py-2 fs-6" onClick={handleTopicFilter}>
                Filter
              </Button>
            </div>
          </div>
          <Row className="inspiration-list">
            {Array.isArray(inspirationData) && inspirationData.length > 0 ? (
              inspirationData.map((inspiration: any) => (
                <Col md="4" key={inspiration.id} className="d-flex">
                  <div className="inspiration-item approval-card">
                    <div className="inspiration-text">{inspiration.description}</div>
                    <div className="inspiration-topic">{inspiration.topics}</div>
                    {/* {<div classNae="inspiration-topic">{inspiration.topics.map(topic => topic.name).join(', ')}</div>} */}
                    {
                      <Col md={12} className="inspiration-img">
                        {/* {inspiration?.imageName ? (
                          <img className="img-thumbnail mb-4 p-0" src={`${baseImageUrl}/${inspiration.imageName}`} />
                        ) : null} */}
                        {renderPreview(inspiration?.imageName)}
                      </Col>
                    }
                    <Row className="approval-card-footer">
                      <Col md="6">{<div className="inspiration-time">{formatDate(inspiration.createdDate)}</div>}</Col>
                      <Col md="6">
                        <p className={`ms-auto ApprovalStatus ${inspiration.approved ? 'Approved' : 'NeedsApproval'}`}>
                          {inspiration.approved ? 'Approved' : 'Pending'}
                        </p>
                      </Col>
                      <div className="inspiration-link">
                        <a href={`${inspiration.link}`}>{inspiration.link}</a>
                      </div>
                      <div className="inspiration-profile-details">
                        <div className="inspiration-user-profile">
                          {inspiration?.user.imageUrl ? (
                            <img className="img-thumbnail p-0" src={`${baseImageUrlProfile}/${inspiration?.user.imageUrl}`} />
                          ) : null}
                          <div className="inspiration-user-name">{inspiration.user.firstName + '' + inspiration.user.lastName}</div>

                          {/* <Button tag={Link} to={`/inspirations/${inspiration.id}/edit`} color="primary" size="sm" data-cy="entityEditButton"> */}
                        </div>
                        <Button
                          onClick={() => {
                            setShowView('edit');
                            setSelectedInspirationId(inspiration.id);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                          color="primary"
                          size="sm"
                          data-cy="entityEditButton"
                        >
                          <FontAwesomeIcon icon="pencil-alt" />{' '}
                          <span className="d-none d-md-inline">{/* <Translate contentKey="entity.action.edit">Edit</Translate> */}</span>
                        </Button>
                      </div>
                    </Row>
                    {/* <Button className="news-dlt-btn" onClick={() => deleteInspiration(inspiration.id)}>
                      <FontAwesomeIcon icon="trash" />{' '}
                      <span className="d-none d-md-inline">
                        <Translate contentKey="entity.action.delete">Delete</Translate>
                      </span>
                    </Button> */}
                  </div>
                </Col>
              ))
            ) : appliedTopics.length > 0 ? (
              <div className="connection-tab-gif">
                <Row className="align-items-center">
                  <div className="col-md-6">
                    <h4>No Results Found</h4>
                    <p>
                      No inspirations were found for the selected topic
                      {appliedTopics.length > 1 ? 's' : ''}. Please try selecting different topics.
                    </p>
                  </div>

                  <div className="col-md-6">
                    <img src="content/images/inspiration_no_content.png" alt="No results found" />
                  </div>
                </Row>
              </div>
            ) : (
              <div className="connection-tab-gif">
                <Row>
                  <div className="col-md-6">
                    {/* <h4>Build Your Professional Network</h4> */}
                    <p>
                      Here you can find and share your own inspiring stories, ideas, and experiences! We encourage you to tap into your own
                      creativity and wisdom to inspire others. Whether it's a personal success story, a motivational quote, or a creative
                      project, this is your platform to uplift and empower the community. So don't be shy – share your inspiration and let's
                      create a positive and supportive space together!
                    </p>
                  </div>
                  <div className="col-md-6">
                    <img src="content/images/inspiration_no_content.png" />
                  </div>
                </Row>
              </div>
            )}
          </Row>
          {totalItems ? (
            <div className={inspirationData && inspirationData.length > 0 ? '' : 'd-none'}>
              <div className="justify-content-center d-flex">
                <JhiItemCount
                  page={paginationState.activePage}
                  total={totalItems}
                  itemsPerPage={paginationState.itemsPerPage}
                  i18nEnabled
                />
              </div>
              <div className="justify-content-center d-flex">
                <JhiPagination
                  activePage={paginationState.activePage}
                  onSelect={handlePagination}
                  maxButtons={5}
                  itemsPerPage={paginationState.itemsPerPage}
                  totalItems={totalItems}
                />
              </div>
            </div>
          ) : (
            ''
          )}
        </>
      )}
    </Container>
  );
};

export default InspirationPage;
